// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"664606c8","198":"b5030306","253":"fad9f73c","456":"e4293bb4","634":"fad9f73c","721":"716c426a","811":"f4b5983a","879":"c6956aad","928":"0e7fc5ea","964":"ede68800"}[chunkId] + ".chunk.js";
};